import { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'urql';
import PageHeader from '../../../components/PageHeader.jsx';
import StickyActions from '../../../components/StickyActions.jsx';
import DataTable from '../../../components/Table/DataTable.jsx';
import { LIST_INGRESOS } from './gql.js';

const columns = [
  { key: 'fecha', label: 'Fecha' },
  { key: 'tipo', label: 'Tipo' },
  { key: 'proveedorNombre', label: 'Proveedor' },
  { key: 'observacion', label: 'Observación' },
];

export default function RecepcionesList({ onCreate, onSelect, refreshKey = 0 }) {
  const [variables, setVariables] = useState({ pagination: { limit: 50, offset: 0 } });
  const [{ data, fetching, error }, reexecute] = useQuery({ query: LIST_INGRESOS, variables });

  useEffect(() => {
    reexecute({ requestPolicy: 'network-only' });
  }, [refreshKey, reexecute]);

  const rows = useMemo(() => data?.listIngresosStock?.items ?? [], [data]);

  return (
    <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-6 px-6 py-8">
      <PageHeader
        title="Recepciones de mercadería"
        subtitle="Controlá los ingresos de stock vinculados a las órdenes de compra."
        actions={
          <button
            type="button"
            onClick={onCreate}
            className="rounded-xl bg-[rgb(var(--brand))] px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-[rgba(var(--brand-700),0.9)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Registrar ingreso
          </button>
        }
      />

      <section className="rounded-2xl border border-[rgb(var(--border))] bg-[rgba(var(--panel),0.7)] p-6 shadow-sm">
        <div className="overflow-hidden rounded-2xl border border-[rgb(var(--border))] bg-[rgba(var(--bg),0.6)]">
          {fetching ? (
            <div className="px-4 py-6 text-sm text-muted">Cargando recepciones…</div>
          ) : error ? (
            <div className="px-4 py-6 text-sm text-red-300">{error.message}</div>
          ) : (
            <DataTable columns={columns} rows={rows} onRowClick={(row) => onSelect?.(row.id)} pageSize={10} />
          )}
        </div>
      </section>

      <StickyActions
        left={<p className="text-sm text-muted">Generá un ingreso para actualizar el stock y el Kardex automáticamente.</p>}
        right={
          <button
            type="button"
            onClick={onCreate}
            className="rounded-xl border border-[rgb(var(--brand))] bg-transparent px-4 py-2 text-sm font-medium text-[rgb(var(--brand))] transition hover:bg-[rgba(var(--brand),0.12)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Registrar ingreso
          </button>
        }
      />
    </div>
  );
}
